import React from "react";
import {Nav} from "react-bootstrap";
import FooterNavLinks from "../FooterNavLinks";

const Footer = () => {
  return (
    <footer className="footer">
      <Nav>
        <FooterNavLinks />
      </Nav>
    </footer>
  );
};
export default Footer;
